import { UnnamedWidget } from 'lib-node-amb-renderer';

import DownloadLink from '~/common/components/DownloadLink';

export class DownloadLinkWidget extends UnnamedWidget {
  text;
  documentId;
  constructor(props) {
    super(props);
    this.text = props.text;
    this.documentId = props.documentId;
  }
}

type DownloadLinkContainerProps = {
  text?: string;
  documentId: number | string;
};

export default function DownloadLinkContainer({
  text,
  documentId,
}: Readonly<DownloadLinkContainerProps>) {
  return <DownloadLink text={text} documentId={+documentId} />;
}
